<template>
<div class="full"
     :style="getStyle()"
     @click="switchControls()"
     v-shortkey.once="{left: ['arrowleft'], right: ['arrowright'], esc: ['esc']}" @shortkey="keyHandler">
    <div class="controls" v-if="areControlsVisible">
        <router-link to="/" class="back">
            <img src="../assets/fleche.svg" style="max-height: 40px" alt="fleche">
            Accueil
        </router-link>

        <div v-for="c in colors" v-bind:key="c.id">
            <button @click.stop="setColor(c.id)" class="color-button">
                <span v-if="isActiveColor(c)">🡲 {{c.name}} 🡰</span>
                <span v-else>{{c.name}}</span>
            </button>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'PixelTest',
    data() {
        const colors = [
            {id: 'black', name: 'noir'},
            {id: 'white', name: 'blanc'},
            {id: 'red', name: 'rouge'},
            {id: 'green', name: 'vert'},
            {id: 'blue', name: 'bleu'},
            {id: 'yellow', name: 'jaune'},
            {id: 'magenta', name: 'magenta'},
            {id: 'cyan', name: 'cyan'},
        ];

        return {
            color: colors[0].id,
            areControlsVisible: true,
            colors,
        };
    },
    methods: {
        setColor(colorId) {
            this.color = colorId;
        },
        getStyle() {
            return {'background-color': this.color};
        },
        switchControls() {
            this.areControlsVisible = !this.areControlsVisible;
        },

        findActualColorIndex() {
            let actualColorIndex = -1;

            for (let i = 0; i < this.colors.length; i++) {
                const color = this.colors[i];

                if (color.id === this.color) {
                    actualColorIndex = i;
                    break;
                }
            }

            return actualColorIndex;
        },

        keyHandler(event) {
            switch (event.srcKey) {
            case 'left':
                this.previousColor();
                break;
            case 'right':
                this.nextColor();
                break;
            case 'esc':
                this.$router.push('/');

                // no default
            }
        },

        nextColor() {
            let index = this.findActualColorIndex() + 1;

            if (index >= this.colors.length) {
                index = 0;
            }

            this.setColor(this.colors[index].id);
        },

        previousColor() {
            let index = this.findActualColorIndex() - 1;

            if (index < 0) {
                index = this.colors.length - 1;
            }

            this.setColor(this.colors[index].id);
        },

        isActiveColor(c) {
            return c.id === this.color;
        }
    }
};
</script>

<style scoped>
.full {
    width: 100%;
    height: 100vh;
    transition: all linear 150ms;
}

.controls {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(233, 235, 231, 0.6);
    border-radius: 15px;
    width: 25vh;
}

.back {
    display: flex;
    color: dimgrey;
    font-weight: 700;
    align-items: center;
}

.color-button {
    background: none;
    border: none;
    margin: auto;
    height: 4vh;
    color: rgba(104, 105, 102, 1);
    font-weight: bold;
    display: block;
    cursor: pointer;
}
</style>
